import { GlobalConfigType } from 'actions/global.config.type'
import cloneDeep from 'clone-deep'
import {
  FieldOrigin,
  InputType,
  IVisibleProp,
  LoanFieldProps,
  loanOptionsConstants,
  MaritalStatusTypes,
  OwnershipTypes,
  OwnRentYearOptions,
  YearOptions,
} from 'config'
import { isCustomFieldKey } from 'config/loan.input.fields.constants'
import { store } from 'reducers'

export const defaultInputs = (_fieldProps: Record<string, IVisibleProp> | null = null): Record<string, InputType> => {
  const { globalConfigReducer } = store.getState()

  const inputs: Record<string, InputType> = {
    hasEntityTitle: {
      inputType: 'toggle',
      title: 'Has Entity Name',
    },
    entityTitle: {
      inputType: 'text',
      title: 'Entity Name',
      fontSize: 24,
      required: true,
    },
    entityAddress: {
      inputType: 'map',
      title: 'Entity Address',
      required: true,
    },
    entityTaxID: {
      inputType: 'text',
      title: 'Entity Tax ID',
      type: 'entityTaxID',
      required: true,
    },
    entityState: {
      title: 'State of Entity',
      inputType: 'select',
      hasDefaultOption: true,
      options: [...loanOptionsConstants.states],
      error: '',
      required: true,
    },
    borrowerType: {
      title: 'Borrower Type',
      inputType: 'Select',
      options: loanOptionsConstants.borrowerType,
      error: '',
      required: true,
      hasDefaultOption: true,
    },
    borrowerPosition: {
      title: 'Borrower Position',
      inputType: 'Select',
      options: [
        'General Partner',
        'Limited Partner',
        'Managing Member',
        'Member',
        'President',
        'Vice President',
        'Secretary',
        'Sole Member',
        'Treasurer',
        'Trustee',
      ],
      error: '',
      required: true,
      hasDefaultOption: true,
    },
    ownershipPercentage: {
      inputType: 'text',
      type: 'number',
      maxNumberRange: 100,
      prefix: '%',
      title: 'Ownership Percentage',
      required: true,
    },
    firstName: {
      inputType: 'text',
      title: 'First Name',
      required: true,
    },
    middleName: {
      inputType: 'text',
      title: 'Middle Name',
    },
    lastName: {
      inputType: 'text',
      title: 'Last Name',
      required: true,
    },
    residency: {
      title: 'Citizenship',
      inputType: 'select',
      hasDefaultOption: true,
      options: loanOptionsConstants.citizenship,
      error: '',
      required: true,
    },
    titleVesting: {
      inputType: 'text',
      title: 'Title Vesting',
      required: true,
    },
    email: {
      inputType: 'text',
      type: 'email',
      title: 'Email',
      required: true,
    },
    ssn: {
      inputType: 'text',
      type: 'ssn',
      title: 'Social Security Number',
      required: true,
    },
    phone: {
      inputType: 'text',
      type: 'phone',
      title: 'Phone',
      required: true,
    },
    dob: {
      inputType: 'text',
      type: 'date',
      title: 'DOB(MM/DD/YYYY)',
      required: true,
    },
    presentAddress: {
      inputType: 'map',
      title: 'Present Address',
      required: true,
      allowForeign: true,
    },
    mailingAddress: {
      inputType: 'map',
      title: 'Mailing Address',
      required: true,
      allowForeign: true,
    },
    ownership: {
      inputType: 'select',
      title: 'Ownership',
      required: true,
      options: OwnershipTypes,
      hasDefaultOption: true,
    },
    ownedRentedYears: {
      inputType: 'select',
      title: 'Owned/Rented Years',
      required: true,
      options: OwnRentYearOptions,
      hasDefaultOption: true,
    },
    formerAddress: {
      inputType: 'map',
      title: 'Former Address',
      allowForeign: true,
      required: true,
    },
    formerOwnership: {
      inputType: 'select',
      title: 'Former Ownership',
      required: true,
      options: OwnershipTypes,
      hasDefaultOption: true,
    },
    formerOwnedRentedYears: {
      inputType: 'select',
      title: 'Former Address Owned For In Years',
      required: true,
      options: YearOptions,
      hasDefaultOption: true,
    },
    maritalStatus: {
      inputType: 'select',
      title: 'Marital Status',
      required: true,
      options: MaritalStatusTypes,
      hasDefaultOption: true,
    },
    hasCoborrower: {
      inputType: 'toggle',
      title: 'Will there be a Co-Borrower or Co-Borrowers?',
    },
    numOfCoBorrowers: {
      inputType: 'text',
      type: 'number',
      title: '# of Other Co-Borrowers',
    },
  }
  for (let i = 1; i < 8; i++) {
    inputs[`coborrower${i}Email`] = {
      inputType: 'text',
      type: 'email',
      title: 'Additional Co-Borrower/Guarantor Email Address',
    }
  }
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  const fieldProps = _fieldProps || loanFieldProperties[FieldOrigin.BorrowerInformation]

  fieldProps &&
    Object.keys(fieldProps).map((key) => {
      if (!isCustomFieldKey(key)) return
      inputs[key] = cloneDeep(fieldProps[key] as any)
    })

  return inputs
}
